import { startSubmit, stopSubmit, SubmissionError } from 'redux-form'
import SERVICES_API_V1 from 'api/services/v1'
import { call, put, takeLatest } from 'redux-saga/effects'
import extractErrors from 'utils/extractErrors'
import { notificationShow } from 'modules/Notifications/actions'
import {
  CAMPAIGNS_LOAD_DATA_FAILED,
  SET_CAMPAIGNS_LIST,
  YANDEX_SUBSCRIPTION_CAMPAIGN_CREATE,
  YANDEX_SUBSCRIPTION_CAMPAIGN_DELETE,
  YANDEX_SUBSCRIPTION_CAMPAIGN_DELETED,
  YANDEX_SUBSCRIPTION_CAMPAIGN_START,
  YANDEX_SUBSCRIPTION_CAMPAIGNS_FETCH,
} from 'modules/Services/types'

function* yandexSubscriptionCampaignCreate({
  payload: { accountId, networkType, data, formName },
  meta: { resolve = () => {}, reject = () => {} } = {},
}) {
  try {
    yield put(startSubmit(formName))
    const { error } = yield call(
      SERVICES_API_V1.createYandexSubscriptionCampaign,
      {
        accountId,
        networkType,
        data,
      },
    )

    if (error) {
      throw error
    }

    yield put(stopSubmit(formName))

    yield put(
      notificationShow({
        type: 'success',
        message: 'common::notifications.data_success_add',
      }),
    )

    resolve()
  } catch (error) {
    const { form, fields } = extractErrors(error.errors)

    reject(fields ? new SubmissionError(fields) : error.statusText)

    if (form) {
      yield put(
        notificationShow({
          type: 'error',
          message: form,
          delay: 10000,
        }),
      )
    }

    console.logXHR(error)
  }
}

function* startYandexSubscriptionCampaign({
  payload: { accountId, networkType, campaignId, data, formName },
  meta: { resolve = () => {}, reject = () => {} } = {},
}) {
  try {
    yield put(startSubmit(formName))
    const { error } = yield call(
      SERVICES_API_V1.startYandexSubscriptionCampaign,
      {
        accountId,
        networkType,
        campaignId,
        data,
      },
    )

    if (error) {
      throw error
    }

    yield put(stopSubmit(formName))

    yield put(
      notificationShow({
        type: 'success',
        message: 'common::notifications.data_success_add',
      }),
    )

    resolve()
  } catch (error) {
    const { form, fields } = extractErrors(error.errors)

    reject(fields ? new SubmissionError(fields) : error.statusText)

    if (form) {
      yield put(
        notificationShow({
          type: 'error',
          message: form,
          delay: 10000,
        }),
      )
    }

    console.logXHR(error)
  }
}

function* loadYandexSubscriptionCampaigns({
  payload: { accountId, networkType },
}) {
  try {
    const { response, error } = yield call(
      SERVICES_API_V1.loadYandexSubscriptionCampaigns,
      { accountId, networkType },
    )

    if (error) {
      throw error
    }

    yield put({
      type: SET_CAMPAIGNS_LIST,
      payload: {
        campaigns: response.data,
        loading: false,
      },
    })
  } catch (error) {
    yield put({ type: CAMPAIGNS_LOAD_DATA_FAILED })
    yield put(
      notificationShow({
        type: 'error',
        message: 'common::notifications.data_fetch_failed',
      }),
    )

    console.logXHR(error)
  }
}

function* deleteYandexSubscriptionCampaigns({
  payload: { accountId, networkType, campaignId },
}) {
  try {
    const { error } = yield call(
      SERVICES_API_V1.deleteYandexSubscriptionCampaigns,
      { accountId, networkType, campaignId },
    )

    if (error) {
      throw error
    }

    yield put({
      type: YANDEX_SUBSCRIPTION_CAMPAIGN_DELETED,
      payload: {
        campaignId,
      },
    })
  } catch (error) {
    yield put(
      notificationShow({
        type: 'error',
        message: 'services::campaign.notifications.delete_failed',
      }),
    )

    console.logXHR(error)
  }
}

export default function* Sagas() {
  yield takeLatest(
    YANDEX_SUBSCRIPTION_CAMPAIGN_CREATE,
    yandexSubscriptionCampaignCreate,
  )
  yield takeLatest(
    YANDEX_SUBSCRIPTION_CAMPAIGN_START,
    startYandexSubscriptionCampaign,
  )
  yield takeLatest(
    YANDEX_SUBSCRIPTION_CAMPAIGNS_FETCH,
    loadYandexSubscriptionCampaigns,
  )
  yield takeLatest(
    YANDEX_SUBSCRIPTION_CAMPAIGN_DELETE,
    deleteYandexSubscriptionCampaigns,
  )
}
